module.exports = __webpack_public_path__ + "static/media/studiofoto-IB_roadbikejpg.9517eaa4.jpg";